<template>
	<div style="width: 10rem;height: calc(100vh - 64px);position: fixed;bottom:0;
    overflow-y: auto;">
		<!-- <div style="padding: 1rem;">
			<img :src="logoimage" alt="" style="width: 8rem;">
		</div> -->
		<div v-for='(item,ind) in menulist'>
			<div>
				<div class='gre-title' @click='item.static = !item.static'>
					<!-- <a-icon type="file-word" /> -->
					<img :src="imglist[ind]" alt="" style="width: 1rem;margin: -0.1rem .1rem 0 0;">
					{{item.name}}
					<!-- <img :src="jtou" alt="" style="width: 1rem;" class='icon-right' :class='item.static?"icon-right0":"icon-right1"'> -->
					<a-icon type="caret-right" theme="filled" class='icon-right'
						:class='item.static?"icon-right0":"icon-right1"' />
				</div>
				<div v-if='item.child'>
					<div :style="{height:item.static?'0px':2*item.child.length+'rem'}" class="warp_top">
						<div v-for="val in item.child" class='wil-list' @click="fam(val)"
							:style='{color:staticadmin == val.type?"#0c8b97":""}'>
							{{val.name}}
						</div>
					</div>
				</div>
			</div>
			<!-- wil-list-tit -->
			<!-- <div v-else class='gre-title'>
				<a-icon type="file-word" />{{item.name}}
			</div> -->
		</div>
		<handfile v-if='staticadmin == "11"||staticadmin == "12"' @child='callhand' :openstatic='openstatic'></handfile>
		<touzhe v-if='staticadmin == "71"||staticadmin == "72"' @child='callhand' :openstatic='openstatic'></touzhe>
		<lispget v-if='staticadmin == "33"||staticadmin == "22"||staticadmin == "23"||staticadmin == "25"'
			@child='callhand' :openstatic='openstatic'></lispget>
		<tkuanzs v-if='staticadmin == "31"' @child='callhand' :openstatic='openstatic'></tkuanzs>
		<getpass v-if='staticadmin == "51"' @child='callhand' :openstatic='openstatic'></getpass>
		<tzcunkuan v-if='staticadmin == "32"' @child='callhand' :openstatic='openstatic'></tzcunkuan>
		<!-- <newcode v-if='staticadmin == "51"' @child='callhand' :openstatic='openstatic'></newcode> -->
		<sifan v-if='staticadmin == "62"' @child='callhand' :openstatic='openstatic'></sifan>
		<dangrchengjiao v-if='staticadmin == "21"' @child='callhand' :openstatic='openstatic'></dangrchengjiao>
		<daichengjiao v-if='staticadmin == "24"' @child='callhand' :openstatic='openstatic'></daichengjiao>
		<!-- 投資組合 折线图 -->
		<areasimple :states='states' v-if='staticadmin=="71-1"'></areasimple>
	</div>
</template>

<script>
	import handfile from '../componhand/handfile.vue'
	import touzhe from '../componhand/touzhe.vue'
	import lispget from '../componhand/lispget.vue'
	import tkuanzs from '../componhand/tkuanzs.vue'
	import getpass from '../componhand/getpass.vue'
	import tzcunkuan from '../componhand/tzcunkuan.vue'
	import sifan from '../componhand/sifan.vue'
	import dangrchengjiao from '../componhand/dangrchengjiao.vue' //當日成交
	import daichengjiao from '../componhand/daichengjiao.vue' //待成交
	import areasimple from '../componhand/areasimple.vue' //待成交

	export default {
		props: ['menulists'],
		components: {
			handfile,
			touzhe,
			lispget,
			tkuanzs,
			getpass,
			tzcunkuan,
			sifan,
			dangrchengjiao,
			daichengjiao,
			areasimple
		},
		data() {
			return {
				logoimage: require('@/image/simu/logoc.png'),
				imglist: [require('@/image/simu/icon_zhengquan.png'),
					require('@/image/simu/icon_xingu.png'),
					require('@/image/simu/tzizh.png'),
					require('@/image/simu/icon_jiaoyi.png'),
					require('@/image/simu/icon_cunkuan.png'),
					require('@/image/simu/icon_zhanghu.png'),
					require('@/image/simu/box.png'),
				],
				staticadmin: '',
				states: {},
				openstatic: {},
				jtou: require('@/image/simu/icon_zhankai.png'),
				menulist: this.menulists,
			}
		},
		mounted() {},
		methods: {
			handleClick(e) {
				console.log('click ', e);
			},
			fam(val) {
				if (val.type == '61') {
					window.open(
						'http://www.qmisgroup.com/Files/Forms/Trade/eform/%E5%A0%B1%E5%83%B9%E6%9C%8D%E5%8B%99%E7%94%B3%E8%AB%8B%E5%8F%8A%E5%8F%96%E6%B6%88-20210316.pdf'
						)
				}
				this.staticadmin = val.type
				this.openstatic = val
			},
			callhand(val, record) {
				this.staticadmin = val ? val : '';
				this.states = record
			},
		}
	}
</script>

<style lang="scss" scoped>
	.icon-right {
		position: absolute;
		right: .5rem;
		top: .5rem;
		width: 1rem;
		transform-origin: center center;
		/*设置图片旋转的中心点为左下角*/
		transition: all 0.5s;
		/*设置旋转的过渡效果：所有都过渡 过渡所需时间为0.8秒*/
	}

	.icon-right1 {
		transform: rotate(90deg);
		/*设置当鼠标经过盒子时第一个img的旋转角度为90°*/
	}

	.icon-right0 {
		transform: rotate(0deg);
		/*设置当鼠标经过盒子时第一个img的旋转角度恢复0°*/
	}

	.warp_top {
		transition: height .5s ease-out;
		-webkit-transition: height .5s ease-out;
		overflow: hidden;
		cursor:pointer;
	}

	.gre-title {
		position: relative;
		background-color: #0C8B96;
		color: #fff;
		padding-left: 1.5rem;
		cursor:pointer;
	}

	.wil-list {
		background-color: #fff;
		color: #000;
		padding-left: 3rem;
	}
	// .wil-list:hover{
	// 	color: rgba(12,139,150,.8);
	// }
	.wil-list-tit {
		background-color: #fff;
		color: #000;
		padding-left: 1.5rem;
	}

	.gre-title,
	.wil-list,
	.wil-list-tit {
		height: 2rem;
		line-height: 2rem;
		font-size: .8rem;
	}
</style>
